import { Component, effect, OnInit, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { NewBinderComponent } from './new-binder.component';
import { Subscription, combineLatest } from 'rxjs';
import { ClientIdServiceService } from '@/services/app/client-id.service';
import { ClientService } from '@/services/api/client.service';
import { HigharcPlanService } from '@/services/api/higharc-plan.service';
import { PlansService } from '@/services/api/plans.service';

@Component({
    selector: 'app-new-binder-container',
    imports: [DialogModule, NewBinderComponent],
    template: `
<app-new-binder [higharc]="higharcMode"></app-new-binder>
    `,
})
export class NewBinderContainerComponent implements OnInit, OnDestroy {
    private route = inject(ActivatedRoute);
    private clientIdService = inject(ClientIdServiceService);
    private clientService = inject(ClientService);
    private higharcPlanService = inject(HigharcPlanService);
    private plansService = inject(PlansService);

    visible: boolean = true;
    clientId: string | null = null;
    hsId: string | null = null;
    builderId: string | null = null;
    planId: string | null = null;
    private routeSubscription: Subscription | null = null;
    higharcMode: boolean = false;

    constructor(
    ) {
    }

    ngOnInit() {
        // Subscribe to both route params and query params
        this.routeSubscription = combineLatest([
            this.route.params,
            this.route.queryParams
        ]).subscribe(([params, queryParams]) => {
            this.clientId = params['clientId'] || null;
            this.planId = queryParams['planId'] || null;
            this.builderId = queryParams['builderId'] || null;
            this.hsId = queryParams['hsid'] || null;
            this.clientIdService.clientId.set(Number(this.clientId));
            this.clientIdService.hsId.set(Number(this.hsId));
            if(this.builderId && this.planId) {
                this.higharcPlanService.getHigharcPlan(this.builderId, this.planId);
                this.higharcMode = true;
            }

            console.log('Route changed - clientId:', this.clientId, 'hsId:', this.hsId);

        });
    }

    ngOnDestroy() {
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
        }
    }

    get header() {
        return !this.clientService.clientData() || this.clientService.clientData().length === 0 || !this.clientService.clientData()[0].ClientLastName || this.clientService.clientData()[0].ClientLastName === null ? 'New Binder' : 'New ' + this.clientService.clientData()[0].ClientLastName + ' Binder'
    }

}

